"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.registerDropdown = exports.BmDropdown = exports.Events = void 0;

var _stringify = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/json/stringify"));

var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));

var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/toConsumableArray"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createSuper"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/taggedTemplateLiteral"));

var _element = require("@blue/element");

var _bmDropdownOption = require("./bm-dropdown-option");

var _bmLoading = require("./bm-loading");

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t\t\t<div class=\"bm-dropdown-container ", "\">\n\t\t\t\t<div class=\"bm-dropdown-header\">\n\t\t\t\t\t<slot name=\"headers\"></slot>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"bm-dropdown-list\">\n\t\t\t\t\t<slot></slot>\n\t\t\t\t\t<bm-loading .active=", "></bm-loading>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t\t\t<div class=\"bm-dropdown\">\n\t\t\t\t<input\n\t\t\t\t\ttype=\"text\"\n\t\t\t\t\tclass=\"bm-dropdown-selection\"\n\t\t\t\t\tplaceholder=\"", "\"\n\t\t\t\t\t.value=", "\n\t\t\t\t\t?readonly=\"", "\"\n\t\t\t\t\t@focus=", "\n\t\t\t\t\t@focusout=", "\n\t\t\t\t\t@mousedown=", "\n\t\t\t\t\t@keydown=", "\n\t\t\t\t\t@input=", "\n\t\t\t\t\t@blur=", "\n\t\t\t\t>\n\t\t\t\t", "\n\t\t\t</div>\n\t\t"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t:host {\n\t\tdisplay: inline-flex;\n\t\tflex-direction: column;\n\t\tposition: relative;\n\t\tmax-width: 270px;\n\t\tmin-width: 120px;\n\t\twidth: 100%;\n\t\tfont-size: 14px;\n\t\tfont-family: arial;\n\t}\n\t:host([hidden]) {\n\t\tdisplay: none;\n\t}\n\t:host([focused]) {\n\t\toutline: 0;\n\t\tbox-shadow: none;\n\t\tbackground-color: #fff;\n\t}\n\t:host::after {\n\t\tposition: absolute;\n\t\tcontent: '';\n\t\tbackground: url(data:image/svg+xml;charset=utf-8;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBmaWxsPSIjMjEyMTIxIiBkPSJNNyAxMGw1IDUgNS01eiIvPjxwYXRoIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiLz48L3N2Zz4=);\n\t\tfont-size: 1.65em;\n\t\toverflow: hidden;\n\t\theight: 1em;\n\t\twidth: 1em;\n\t\tright: 0.2em;\n\t\ttop: 0.1em;\n\t\tcursor: pointer;\n\t}\n\n\t:host > * {\n\t\tflex-grow: 1;\n\t}\n\n\t/* The text input box */\n\t.bm-dropdown-selection {\n\t\ttransition: border-color ease-in-out 0.2s;\n\t\tborder: 1px solid #ccc;\n\t\tborder-radius: 0;\n\t\theight: 30px;\n\t\tcolor: #37383d;\n\t\tbackground-color: transparent;\n\t\tbox-shadow: none;\n\t\tpadding: 0px 12px;\n\t\tfont-size: 14px;\n\t\tline-height: 30px;\n\t\tflex-grow: 1;\n\t\ttext-indent: 0.01px;\n\t\twidth: 100%;\n\t\ttext-overflow: ellipsis;\n\t\tbox-sizing: border-box;\n\t}\n\t.bm-dropdown-selection:focus {\n\t\toutline: 0;\n\t\tbox-shadow: none;\n\t\tborder-color: #3c3e45;\n\t}\n\t.bm-dropdown-selection[disabled] {\n\t\tcolor: #606169;\n\t\tbackground-color: #f4f5f7;\n\t\tborder-color: #b2b2b8;\n\t\tcursor: default;\n\t}\n\t.bm-dropdown-selection[readonly] {\n\t\tcursor: pointer;\n\t}\n\t.bm-dropdown-selection.invalid {\n\t\tborder-color: #dc0a0a;\n\t\tborder-color: var(--danger, #dc0a0a) !important;\n\t}\n\n\t.bm-dropdown-container {\n\t\tdisplay: block;\n\t\tmax-height: 300px; /* TODO: Make this variable */\n\t\tborder: 1px #000 solid;\n\t\twidth: max-content;\n\t\toverflow-y: scroll;\n\t\tposition: absolute;\n\t\tz-index: 1;\n\t\tbackground-color: white;\n\t}\n\n\t.bm-dropdown-container.hide {\n\t\tdisplay: none;\n\t}\n\n\t.bm-dropdown-header {\n\t\tdisplay: table-header-group;\n\t\tbackground-color: #f4f5f7;\n\t\tborder-bottom: 1px solid #d5d4d9;\n\t\tfont-weight: bold;\n\t}\n\n\t.bm-dropdown-list {\n\t\tdisplay: table-row-group;\n\t\tpadding: 0;\n\t\tmargin: 0;\n\t\tcursor: pointer;\n\t\toverflow-y: scroll;\n\t\toverflow-x: hidden;\n\t\twidth: 100%;\n\t\tmax-height: 300px;\n\t}\n\n\t::slotted([highlighted]) {\n\t\tbackground-color: #d4ebf4;\n\t}\n\n\tbm-loading {\n\t\tposition: relative;\n\t\tbackground-color: white;\n\t\theight: 36px;\n\t\tjustify-content: start;\n\t\tpadding-left: 13px;\n\t\tcursor: default;\n\t}\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var inputDebounce = 200;
var Events;
exports.Events = Events;

(function (Events) {
  Events["SELECT"] = "select";
  Events["INPUT"] = "userInput";
})(Events || (exports.Events = Events = {}));

var style = (0, _element.css)(_templateObject());
var forceWrite = (0, _element.directive)(function (value) {
  return function (part) {
    part.setValue(value);
  };
});

var BmDropdown = /*#__PURE__*/function (_BlueElement) {
  (0, _inherits2.default)(BmDropdown, _BlueElement);

  var _super = (0, _createSuper2.default)(BmDropdown);

  function BmDropdown() {
    var _context;

    var _this;

    (0, _classCallCheck2.default)(this, BmDropdown);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, (0, _concat.default)(_context = [this]).call(_context, args));
    _this.placeholder = '';
    _this.allowInput = false;
    _this.isOpen = false;
    _this.selected = void 0;
    _this.loading = false;
    _this.isTypingValue = false;
    _this._options = [];
    _this._highlighted = void 0;
    _this._debounceTimeout = void 0;
    return _this;
  }

  (0, _createClass2.default)(BmDropdown, [{
    key: "firstUpdated",
    value: function firstUpdated() {
      var _this2 = this;

      this.shadowRoot.addEventListener('slotchange', function () {
        return _this2._processOptions();
      });
      this.addEventListener('click', function () {
        return _this2._onFocus();
      });

      this._processOptions();
    }
  }, {
    key: "updated",
    value: function updated(changed) {
      if (changed.has('isOpen') && !changed.get('isOpen')) {
        this._clearHighlight();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var inputValue = this.selected ? this.selected.selectedDisplayValue : this.placeholder;
      var updateValue = this.isTypingValue ? inputValue : forceWrite(inputValue);
      return this.html(_templateObject2(), this.placeholder, updateValue, !this.allowInput, function () {
        return _this3._onFocus();
      }, function () {
        return _this3._onFocusOut();
      }, function () {
        return _this3._setIsOpen(true);
      }, function (e) {
        return _this3._onInputKeydown(e.key);
      }, function () {
        return _this3._onInputChange();
      }, function () {
        return _this3._setIsOpen(false);
      }, this._renderList());
    }
  }, {
    key: "_processOptions",
    value: function _processOptions() {
      var _context2,
          _this4 = this,
          _context3,
          _context4;

      this._options = (0, _toConsumableArray2.default)(this.querySelectorAll('bm-dropdown-option'));
      (0, _forEach.default)(_context2 = this._options).call(_context2, function (option) {
        return _this4._attachOptionListeners(option);
      });
      var selected = (0, _filter.default)(_context3 = this._options).call(_context3, function (option) {
        return option.selected;
      });

      if (selected.length > 0) {
        this._selectOption(selected[0]);

        var updated = this.performUpdate();

        if (updated) {
          updated.catch(console.error);
        }
      }

      (0, _forEach.default)(_context4 = this._options).call(_context4, function (option) {
        option.processed = true;
      });
    }
  }, {
    key: "_renderList",
    value: function _renderList() {
      return this.html(_templateObject3(), (0, _element.classMap)({
        hide: !this.isOpen
      }), this.loading);
    }
  }, {
    key: "_setIsOpen",
    value: function _setIsOpen(isOpen) {
      this.isOpen = isOpen;
    }
  }, {
    key: "_attachOptionListeners",
    value: function _attachOptionListeners(option) {
      var _this5 = this;

      if (!option.processed) {
        option.addEventListener('mousemove', function () {
          return _this5._highlightOption(option);
        });
        option.addEventListener('mousedown', function () {
          return _this5._selectOption(option);
        });
        option.addEventListener('selected', function (e) {
          _this5._selectOption(e.detail);
        });
      }
    }
  }, {
    key: "_clearHighlight",
    value: function _clearHighlight() {
      if (this._highlighted) {
        this._highlighted.removeAttribute('highlighted');

        this._highlighted = undefined;
      }
    }
  }, {
    key: "_highlightOption",
    value: function _highlightOption(option) {
      if (option === this._highlighted || !option.canSelect) {
        return;
      }

      this._clearHighlight();

      option.setAttribute('highlighted', 'true');
      this._highlighted = option;
    }
  }, {
    key: "_nextSelectableOption",
    value: function _nextSelectableOption(direction, option) {
      if (this._options.length === 0) {
        return null;
      }

      if (!option) {
        if (this._options[0].canSelect) {
          return this._options[0];
        }

        option = this._options[0];
      }

      var next = direction > 0 ? option.nextElementSibling : option.previousElementSibling;

      if (!next) {
        return null;
      }

      if (!(next instanceof _bmDropdownOption.BmDropdownOption)) {
        throw new TypeError('Non-BmDropdownOption element in list: ' + (0, _stringify.default)(next));
      }

      if (!next.canSelect) {
        return this._nextSelectableOption(direction, next);
      }

      return next;
    }
  }, {
    key: "_moveHighlight",
    value: function _moveHighlight(direction) {
      var next = this._nextSelectableOption(direction, this._highlighted);

      if (next) {
        this._highlightOption(next);

        this._scrollToOption(next);
      }
    }
  }, {
    key: "_scrollToOption",
    value: function _scrollToOption(option) {
      option.scrollIntoView({
        block: 'nearest',
        inline: 'start'
      });
    }
  }, {
    key: "_selectOption",
    value: function _selectOption(option) {
      var _context5;

      (0, _forEach.default)(_context5 = this._options).call(_context5, function (opt) {
        opt.selected = opt === option;
      });

      if (option) {
        this.selected = option;
        this.isTypingValue = false;
        this.dispatchEvent(new CustomEvent(Events.SELECT, {
          detail: this.selected.value
        }));
        this.isOpen = false;
      }
    }
  }, {
    key: "_onInputChange",
    value: function _onInputChange() {
      var _this6 = this;

      this._selectOption(null);

      if (this._debounceTimeout) {
        window.clearTimeout(this._debounceTimeout);
      }

      this._debounceTimeout = window.setTimeout(function () {
        _this6.dispatchEvent(new CustomEvent(Events.INPUT, {
          detail: _this6._inputElement.value
        }));

        _this6._debounceTimeout = undefined;
      }, inputDebounce);
    }
  }, {
    key: "_onInputKeydown",
    value: function _onInputKeydown(key) {
      if (!this.isOpen) {
        this.isOpen = true;
      }

      if (key === 'ArrowDown') {
        this._moveHighlight(1);
      } else if (key === 'ArrowUp') {
        this._moveHighlight(-1);
      } else if ((key === 'Enter' || key === 'Tab') && this._highlighted) {
        this._selectOption(this._highlighted);
      } else if (key === 'Escape') {
        this.isOpen = false;
      } else {
        this.isTypingValue = true;
      }
    }
  }, {
    key: "_onFocus",
    value: function _onFocus() {
      this._setIsOpen(true);

      this._inputElement.select();
    }
  }, {
    key: "_onFocusOut",
    value: function _onFocusOut() {
      this.isTypingValue = false;
      this.requestUpdate().catch(console.error);
    }
  }, {
    key: "_inputElement",
    get: function get() {
      return this.shadowRoot.querySelector('.bm-dropdown-selection');
    }
  }], [{
    key: "is",
    get: function get() {
      return 'bm-dropdown';
    }
  }, {
    key: "properties",
    get: function get() {
      return {
        placeholder: {
          type: String
        },
        allowInput: {
          type: Boolean,
          attribute: 'allow-input'
        },
        isOpen: {
          type: Boolean,
          attribute: 'is-open',
          reflect: true
        },
        selected: {
          type: Object,
          attribute: false
        },
        loading: {
          type: Boolean
        }
      };
    }
  }, {
    key: "styles",
    get: function get() {
      return style;
    }
  }]);
  return BmDropdown;
}(_element.BlueElement);

exports.BmDropdown = BmDropdown;

var registerDropdown = function registerDropdown() {
  (0, _bmDropdownOption.registerDropdownOption)();
  (0, _bmLoading.registerLoading)();
  (0, _element.register)(BmDropdown);
};

exports.registerDropdown = registerDropdown;
